import { render, staticRenderFns } from "./variationTestDetail.vue?vue&type=template&id=c3a61426&scoped=true"
import script from "./variationTestDetail.vue?vue&type=script&lang=js"
export * from "./variationTestDetail.vue?vue&type=script&lang=js"
import style0 from "./variationTestDetail.vue?vue&type=style&index=0&id=c3a61426&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a61426",
  null
  
)

export default component.exports